import { format } from "date-fns";
import { pt } from "date-fns/locale";
import { getLang } from "@/i18n";

export const nf = { format: (n) => new Intl.NumberFormat(getLang() === "pt" ? "pt-PT" : "en-US").format(n) };

const NAIVE_ISO = /T\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/;

export const fmtDate = (value, pattern = "dd MMM yyyy") => {
  if (!value) return "—";
  const d = new Date(typeof value === "string" && NAIVE_ISO.test(value) ? `${value}Z` : value);
  return Number.isNaN(d.getTime()) ? "—" : format(d, pattern, getLang() === "pt" ? { locale: pt } : undefined);
};

export const fullName = (u) => [u.first_name, u.last_name].filter(Boolean).join(" ") || u.full_name_certificate || u.username || "—";
